import React, { Fragment } from 'react'
import { isEmpty } from 'lodash'

import Dropdown from '@ublique/components/Dropdown'
import MultiSelect from '@ublique/components/MultiSelect'

import PermissionBlock from './PermissionBlock'

const CreationForm = ({
  t,
  values,
  errors,
  onChange,
  roles,
  blocksList,
  onAddBlock,
  scenarioFields,
  onRemoveBlock,
  onBlockChange,
  selectedTypes,
  remainingTypes
}) => {
  const itemToString = (item) => (item ? t(item.label) : '')

  return (
    <Fragment>
      <Dropdown
        id='roles'
        titleText={t('RolesManagement.InstancesModal.Roles')}
        label={t('RolesManagement.InstancesModal.Roles')}
        placeholder={t('RolesManagement.InstancesModal.Roles')}
        selectedItem={
          !isEmpty(values.role)
            ? {
                label: values?.role,
                value: values?.role
              }
            : null
        }
        invalidText={errors?.role ? t(`ScenarioManagement.${errors.role}`) : ''}
        invalid={!isEmpty(errors?.role)}
        onChange={({ selectedItem }) =>
          onChange({
            role: selectedItem.value
          })
        }
        name='roles'
        items={roles?.map((role) => ({
          label: role?.roleName,
          value: role?.roleName
        }))}
        itemToString={itemToString}
      />
      <MultiSelect
        id='fields'
        useTitleInItem={false}
        initialSelectedItems={!isEmpty(values?.fields) ? values?.fields : []}
        titleText={t('ScenarioManagement.Fields')}
        label={t('ScenarioManagement.Fields')}
        light
        name='fields'
        value={values?.fields}
        onChange={({ selectedItems }) =>
          onChange({
            fields: selectedItems
          })
        }
        items={scenarioFields.map((field) => ({
          label: field,
          value: field
        }))}
        itemToString={itemToString}
      />
      {blocksList.map((id, index) => (
        <PermissionBlock
          t={t}
          key={id}
          onAdd={onAddBlock}
          onRemove={() => onRemoveBlock(id)}
          onFormChange={onBlockChange(id)}
          values={values.blocks?.[id] ?? {}}
          showAddButton={
            remainingTypes.length > 0 && selectedTypes.length !== 0
          }
          errors={errors?.[id]}
          firstBlock={index === 0}
          scenarioItems={remainingTypes}
        />
      ))}
    </Fragment>
  )
}

export default CreationForm
